import clsx from 'clsx'

export const Container = ({ children, className = '', ...restProps }) => {
  return (
    <div
      className={clsx('container mx-auto px-4 md:px-0', className)}
      {...restProps}
    >
      {children}
    </div>
  )
}

export const ContainerNoPadding = ({
  children,
  className = '',
  ...restProps
}) => {
  return (
    <div className={clsx('container mx-auto', className)} {...restProps}>
      {children}
    </div>
  )
}

export const ContainerSectionNoPadding = ({
  children,
  className = '',
  ...restProps
}) => {
  return (
    <section className={clsx('container mx-auto', className)} {...restProps}>
      {children}
    </section>
  )
}

export const ContainerSection = ({
  children,
  className = '',
  ...restProps
}) => {
  return (
    <section
      className={clsx('container mx-auto px-4 md:px-0', className)}
      {...restProps}
    >
      {children}
    </section>
  )
}

export const ContainerUsingMargin = ({
  children,
  className = '',
  ...restProps
}) => {
  return (
    <div className={clsx('container mx-auto')}>
      <div className={clsx('mx-4 md:mx-0', className)} {...restProps}>
        {children}
      </div>
    </div>
  )
}
